module.exports = __webpack_public_path__ + "static/media/SPIKE_TELEPORT_SYSTEM_IMAGE.3f270a1a.png";